import * as React from "react"
import type { SVGProps } from "react"
export const TerminalIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4.308 19.5q-.758 0-1.283-.525a1.75 1.75 0 0 1-.525-1.283V6.308q0-.758.525-1.283T4.308 4.5h15.384q.758 0 1.283.525t.525 1.283v11.384q0 .758-.525 1.283t-1.283.525zm0-1.5h15.384a.3.3 0 0 0 .212-.096.3.3 0 0 0 .096-.212V8H4v9.692q0 .116.096.212a.3.3 0 0 0 .212.096m4.723-5-2.073-2.073a.71.71 0 0 1-.22-.527.72.72 0 0 1 .235-.527.76.76 0 0 1 .527-.21.71.71 0 0 1 .527.22l2.485 2.484q.27.271.27.633 0 .361-.27.633l-2.495 2.494a.7.7 0 0 1-.514.21.72.72 0 0 1-.53-.22.7.7 0 0 1-.207-.517q0-.31.207-.517zM13 16.75a.73.73 0 0 1-.534-.215.73.73 0 0 1-.216-.535q0-.32.216-.534A.73.73 0 0 1 13 15.25h4q.32 0 .535.216a.73.73 0 0 1 .215.534.73.73 0 0 1-.215.535.73.73 0 0 1-.535.215z"
    ></path>
  </svg>
)
